module.exports = __webpack_public_path__ + "img/gi.549014d9.svg";